/**
 * Color-coded status indicator + optional label text.
 *
 * Three states map to colors:
 *   emerald — healthy / online / approved
 *   amber   — degraded / stuck / requires attention
 *   zinc    — offline / unknown / loading
 *
 * Shared between AgentStatusBadge (agent-centric) and Hosts page (host-centric).
 */
export type DotColor = "emerald" | "zinc" | "amber";

export function StatusDot({ color, text }: { color: DotColor; text?: string }) {
	const dotClass =
		color === "emerald"
			? "bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.6)]"
			: color === "amber"
				? "bg-amber-400 shadow-[0_0_6px_rgba(251,191,36,0.6)]"
				: "bg-zinc-600";
	const textClass =
		color === "emerald" ? "text-emerald-300" : color === "amber" ? "text-amber-300" : "text-zinc-500";
	if (text === undefined) {
		return <span className={`inline-block w-2 h-2 rounded-full ${dotClass}`} aria-label={color} />;
	}
	return (
		<div className={`text-xs flex items-center gap-1.5 ${textClass}`}>
			<span className={`inline-block w-2 h-2 rounded-full ${dotClass}`} />
			<span>{text}</span>
		</div>
	);
}
